import React, { useRef } from 'react';
import { TWModal } from '../../../../components/ui';

const sizeMap = {
  sm: 'md',
  md: 'xl',
  lg: '3xl',
  xl: '4xl',
};

export default function DialogShell({
  show,
  onClose,
  title,
  description,
  children,
  footer,
  size = 'md',
  closeOnBackdrop = true,
}) {
  const cancelRef = useRef(null);

  return (
    <TWModal
      open={!!show}
      onClose={onClose}
      title={title}
      description={description}
      size={sizeMap[size] || 'xl'}
      dismissible={closeOnBackdrop}
      showCloseButton
      initialFocus={cancelRef}
      bodyClassName="max-h-[70vh] overflow-y-auto"
      footer={footer}
    >
      {children}
    </TWModal>
  );
}
